<template>
<!-- 项目内头部 -->
    <div class="header-container header-bg" :style="headerBg">
        <div class="menu-container clearfix">
            <div class="logo">
               <a href="javascript:;"><span class="logo-title">春梅信息</span></a>
            </div>
            <!-- 折叠按钮 -->
            <div class="collapse-btn" @click="collapseChage">
                <i :class="collapse? 'iconfont icon-menu-fold' : 'iconfont icon-menu-unfold'"></i>
            </div>
            <div style="overflow:hidden;">
                <!-- 切换主题色 -->
                <el-color-picker class="right-menu changeBg" size="small" show-alpha v-model="color1" @change="handleChangeColor"></el-color-picker>
                <!-- 导航栏右侧 -->
                <el-dropdown class="right-menu" @command="handleLangCommand">
                    <div class="el-dropdown-link">
                        {{$t('lang')}}
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="cn">
                            中文
                        </el-dropdown-item>
                        <el-dropdown-item command="en">
                            English
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-dropdown class="right-menu" @command="handleLogoutCommand">
                    <div class="el-dropdown-link">
                        <i v-if="user.avatar === ''|| user.avatar === undefined" class="el-icon-user-solid"></i>
                        <img v-else :src="user.avatar" alt="" class="avatar" style="padding-left: 8px;">
                        {{user.username}}
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="changepassword">
                            {{$t('menu.headchangePassword')}}
                        </el-dropdown-item>
                        <el-dropdown-item command="logout">
                            {{$t('header.logout')}}
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
    </div>

</template>

<script>
import bus from "@/utils/bus";
import { mapGetters } from "vuex";
import Storage from '@/utils/storage'

// require("./header.css");
export default {
    name: "adminheader",
    inject: ["reload"],
    data() {
        return {
            collapse: false,
            color1: 'rgb(41, 61, 110)',
            headerBg: '',
        };
    },
    components: {},
    computed: {
        ...mapGetters(["user"])
    },
    created() {
        // 获取用户信息
        let headerBg = Storage.get("headerBg") || this.color1;
        let val = headerBg.headerBg || headerBg;
        this.headerBg =  "background-color:"+ val;
        this.color1 = val;
    },
    mounted() {
        // 窗口响应式
        if (document.body.clientWidth < 900) {
            this.collapseChage();
        }
        window.onresize = () => {
            if(window.innerWidth<900 && !this.collapse) {
                this.collapseChage();
            } 
            if(window.innerWidth>900 && this.collapse) {
                this.collapseChage();
            }
            
        }
    },
    methods: {
        handleLangCommand(command) {
            this.$i18n.locale = command;
            Storage.set("lang", {lang:command});
        },
        handleLogoutCommand(command) {
            switch (command) {
				case "changepassword":
					this.$router.push({ path: "/changepassword" });
					break;
                case "logout":
                    this.handleLogout();
                    break;
                case "userCenter":
                    break;
                default:
                    break;
            }
        },
        // 退出登录
        handleLogout() {
            this.$store.dispatch("LogOut").then(()=> {
                location.href = '/login'
            })
        },
        // 
        collapseChage() {
            this.collapse = !this.collapse;
            bus.$emit("collapse", this.collapse);
        },
        handleChangeColor(val) {
            this.headerBg = "background-color:"+ val;
            Storage.set("headerBg", {headerBg:val});
        },
    },
};
</script>

<style scoped lang="less">
.header-container {
    flex: 0 0 auto;
    background-color: @header-bgcolor;
}
.menu-container .right-menu .svg-icon {
    fill: #fff !important;
}
.menu-container .right-menu:hover {
    cursor: pointer;
    color: #fff;
}
.collapse-btn {
    float: left;
    padding: 0 21px;
    cursor: pointer;
    line-height: 60px;
    color: #fff;
    height: 60px;
}
.collapse-btn i {
    font-size: 22px;
}
.logo-title{
    line-height: 60px;
    margin: 0 30px;
    font-size: 22px;
    color: #fff;
}
.logo a{
    text-decoration: none;
}
</style>

